import React from "react";

const HowYouMetUs = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 5.5A2.5 2.5 0 0 1 5.5 3h13A2.5 2.5 0 0 1 21 5.5v9a2.5 2.5 0 0 1-2.5 2.5H13l-4.4 3.85A1 1 0 0 1 7 20.1V17H5.5A2.5 2.5 0 0 1 3 14.5v-9Zm2.5-.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5H8a1 1 0 0 1 1 1v2.41l3.34-2.92a1 1 0 0 1 .66-.24h5.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13ZM7 8h10v2H7V8Zm0 3.5h7v2H7v-2Z"
        />
    </svg>
);

export default HowYouMetUs;
